// keys and student routes of menu items
export const studentUIPaths = {
  "contact-us": ["contact-us"],
  "feedback": ["feedback"],
  "my-profile": ["my-profile"],
  "logout": ["logout"],
  "student-dashboard": [
    "student-dashboard",
    "image-listing",
    "video-listing",
    "video-preview",
    "animation-listing",
    "resource-listing",
  ],
  "home": ["home", "student-login"],
  "help": [
    "help",
    "how-do-i-access-the-online-resources",
    "how-do-i-find-the-access-code-to-register-for-the-practice-exams",
    "can-someone-else-use-my-subscription",
    "why-is-my-book-code-invalid",
    "i-did-not-receive-an-email-after-registration-what-do-i-do",
    "i-am-not-receiving-mails-from-this-site",
    "what-should-i-do-if-i-have-forgotten-my-username-or-password",
    "how-long-will-i-be-able-to-access-my-account",
    "what-should-i-do-if-i-cannot-access-the-online-resources",
    "why-can-t-i-login-my-account",
  ],
  "acknowledgements": ["acknowledgements"],
};

// keys and admin routes of menu items
export const adminUIPaths = {
  "admin-dashboard": ["admin-dashboard"],
  "admin-users": ["admin-users"],
  "student-users": ["student-users"],
  "generate-codes": ["generate-codes"],
  "book-code-list": ["book-code-list"],
  "images": ["image-listing"],
  "videos": ["video-listing", "video-preview", "video-edit"],
  "animations": ["animation-listing"],
  "my-profile": ["my-profile"],
  "logout": ["logout"],
  "universities": ["university-master", "add-university"],
  "documents": ["document-listing"],
  "settings": ["settings"],
  "crons" : ["cron-activity", "response-data"]
};